import HttpRequest from "./HttpRequest";

class DashboardParkService {

  static async getDashboardData(bizLocation, date, page) {

    let requestParam = new URLSearchParams();
    requestParam.append('page', page);

    bizLocation && requestParam.append('_bizLocation', bizLocation);
    date && requestParam.append('stockDate', date.toISOString());


    let endpoint = `/ton/v1/stock-levels/biz-locations/summary?${requestParam.toString()}&size=20`;
    const httpRequest = new HttpRequest();
    return await httpRequest.get(endpoint);
  }
}

export { DashboardParkService }



// WEBPACK FOOTER //
// ./src/services/DashboardParkService.js